module.exports = __webpack_public_path__ + "static/illustration1-3a350791a7066205fbb9cfc55aefa163.png";